import { MENU } from "@/utils/constants/constants.menu";
import _ from "lodash";

/** 框架 布局相关 **/
const layout = {
  namespaced: true,
  state: {
    useLayout: true,
    pageTitle: "",
    header: "",
    routeRecords: [],
    isShowMenu: false,
    // 菜单
    menu: _.cloneDeep(MENU),
    menuDefaultOpens: ["2", "3", "6"],
    sidebar: { show: true, auto_bay: [] },
    isShowFooter: true,
  },
  getters: {
    useLayout: (state) => state.useLayout,
    pageTitle: (state) => state.pageTitle,
    header: (state) => state.header,
    routeRecords: (state) => state.routeRecords,
    isShowMenu: (state) => state.isShowMenu,
    menu: (state) => state.menu,
    menuDefaultOpens: (state) => state.menuDefaultOpens,
    sidebar: (state) => state.sidebar,
    isShowFooter: (state) => state.isShowFooter,
  },
  mutations: {
    updateUseLayout(state, useLayout) {
      state.useLayout = useLayout;
    },
    updatePageTitle(state, pageTitle) {
      state.pageTitle = pageTitle;
    },
    updateHeader(state, header) {
      state.header = header;
    },
    updateRouteRecords(state, routeRecords) {
      state.routeRecords = routeRecords;
    },
    updateIsShowMenu(state, isShowMenu) {
      state.isShowMenu = isShowMenu;
    },
    updateMenu(state, menu) {
      state.menu = menu;
    },
    updateMenuDefaultOpens(state, menuDefaultOpens) {
      state.menuDefaultOpens = menuDefaultOpens;
    },
    updateSidebar(state, sidebar) {
      state.sidebar = sidebar;
    },
    updateIsShowFooter(state, isShowFooter) {
      state.isShowFooter = isShowFooter;
    },
  },
  actions: {},
};
export default layout;
